import { connect } from 'react-redux';
import { showReportModal as showReportModalAction } from '../../../../Moderation/redux/actions';
import { deleteDeviation as deleteDeviationAction } from '../../../../redux/deviations/actionCreators';
import { showMobileDeviationSharePopup } from '../../../../Modals/redux/actionCreators';
import { addNotification } from '../../../../Notifications/redux/actionCreators';
import { NotificationType } from '../../../../Notifications/redux/types';
const mapDispatchToProps = (dispatch, { deviation })=>{
    return {
        showReportModal: ()=>dispatch(showReportModalAction(deviation)),
        deleteDeviation: ()=>dispatch(deleteDeviationAction({
                deviation
            })),
        showMobileSharePopup: ()=>dispatch(showMobileDeviationSharePopup(deviation)),
        showGenericNotification: (params)=>dispatch(addNotification(NotificationType.Generic, params))
    };
};
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=FeedCardLayout.container.js.map